import { ValueOf } from '@/types/util';

export const ECreditCardGw = {
  GMO_PAYMENT_GATEWAY: 'GMOペイメントゲートウェイ',
  DGFT: 'DGFT',
} as const;

export type CreditCardGwKey = keyof typeof ECreditCardGw;
export type CreditCardGwValue = ValueOf<typeof ECreditCardGw>;

// eslint-disable-next-line max-len
export const creditCardGwKeys = Object.keys(ECreditCardGw) as CreditCardGwKey[];

/** v-select用items */
export const creditCardGwItems = creditCardGwKeys
  .map((key) => ({
    title: ECreditCardGw[key],
    value: key,
  }));
